import galleryBeer from "../assets/burgersson-baconcheese-scaled.jpg";
import galleryFries from "../assets/burgersson-caesar-sallad-scaled.jpg";
import galleryBurger2 from "../assets/burgersson-cheers-scaled.jpg";
import galleryShake from "../assets/burgersson-chili-burgare-scaled.jpg";
import gallerySalad from "../assets/burgersson-kvall-scaled.jpg";
import galleryTakeaway from "../assets/burgersson-takeaway-scaled.jpg";
import heroBurger from "../assets/burgersson-monthly-burgare-scaled.jpg";
import heroInterior from "../assets/Burgersson-Hamburgare.jpg";

const images = [
  { src: galleryBeer, alt: "Craft Beer" },
  { src: galleryFries, alt: "French Fries" },
  { src: galleryBurger2, alt: "Cheeseburger" },
  { src: galleryShake, alt: "Milkshake" },
  { src: gallerySalad, alt: "Caesar Salad" },
  { src: heroBurger, alt: "Burger" },
  { src: galleryTakeaway, alt: "Takeaway" },
  { src: heroInterior, alt: "Restaurant Interior" },
];

const Gallery = () => {
  return (
    <section className="py-0">
      <div className="grid grid-cols-2 md:grid-cols-4">
        {images.map((img, i) => (
          <div key={i} className="relative overflow-hidden aspect-square group">
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              loading="lazy"
              width={800}
              height={800}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
